import { render, staticRenderFns } from "./AISummaryConfirmDialog.vue?vue&type=template&id=2d22fb5c&scoped=true"
import script from "./AISummaryConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AISummaryConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AISummaryConfirmDialog.vue?vue&type=style&index=0&id=2d22fb5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22fb5c",
  null
  
)

export default component.exports